module.exports = __webpack_public_path__ + "1aa6e9edca6bada49eece9dc367fd1ae.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/XK.svg
// module id = i0hu
// module chunks = 0